module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.2809/js/img/productIcons/Sales_Starter.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/productIcons/Sales_Starter.svg
// module id = 753
// module chunks = 3 4